import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
// import emailjs from "@emailjs/browser";
import { ServicePackage } from "../types/ServicePackage";

const getStorageKey = (pkg: ServicePackage) =>
  `beme_inquiry_${pkg}_submitted`;

const packageCopy = {
  [ServicePackage.FULL]: {
    title: "£300 패키지 정보 제출",
    description: "전체 CV / CL / LinkedIn / STAR 분석을 위한 정보 입력",
    priceLabel: "£300 Full Package",
  },
  [ServicePackage.REALITY]: {
    title: "£59 Reality Check 제출",
    description: "빠른 CV 진단 + 핵심 개선 포인트 제공",
    priceLabel: "£59 Reality Check",
  },
};

const ServiceRequestForm: React.FC = () => {
  const [params] = useSearchParams();
  const pkg =
    (params.get("package") as ServicePackage) ?? ServicePackage.FULL;

  const storageKey = getStorageKey(pkg);
  const copy = packageCopy[pkg];

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState<any>({
    name: "",
    email: "",
    concern: "",
    situation: "",
    experience: "",
    source: "",
    cv: null,
  });

  useEffect(() => {
    if (localStorage.getItem(storageKey) === "true") {
      setSubmitted(true);
    }
  }, [storageKey]);

  const handleChange = (e: any) => {
    const { name, value, files } = e.target;
    setFormData((prev: any) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);

    try {
    //   await emailjs.send(
    //     "YOUR_SERVICE_ID",
    //     "YOUR_TEMPLATE_ID",
    //     {
    //       package: copy.priceLabel,
    //       name: formData.name,
    //       email: formData.email,
    //       concern: formData.concern,
    //       situation: formData.situation,
    //       experience: formData.experience,
    //       source: formData.source,
    //     },
    //     "YOUR_PUBLIC_KEY"
    //   );

      console.group(`📨 Inquiry Sent [${copy.priceLabel}]`);
      console.log(formData);
      console.groupEnd();

      localStorage.setItem(storageKey, "true");
      setSubmitted(true);
    } catch (err) {
      alert("제출 중 오류가 발생했습니다. 다시 시도해주세요.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-24 bg-sub">
      <div className="max-w-3xl mx-auto px-4">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-3xl font-bold text-main text-center mb-4"
        >
          {copy.title}
        </motion.h2>

        <p className="text-center text-gray-600 mb-10">
          {copy.description}
        </p>

        {submitted ? (
          <div className="bg-white p-10 rounded-2xl shadow text-center">
            <h3 className="text-xl font-bold mb-2">제출 완료</h3>
            <p className="text-gray-600 leading-relaxed">
              이미 제출하신 패키지입니다.
              <br />
              영업일 기준 1–2일 내로 안내드릴게요.
            </p>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="bg-white p-8 rounded-2xl shadow space-y-6"
          >
            <input
              name="name"
              required
              placeholder="이름 *"
              onChange={handleChange}
              className="w-full border rounded-lg px-4 py-3"
            />

            <input
              name="email"
              type="email"
              required
              placeholder="이메일 *"
              onChange={handleChange}
              className="w-full border rounded-lg px-4 py-3"
            />

            <textarea
              name="concern"
              required
              placeholder="지금 가장 고민되는 점 *"
              onChange={handleChange}
              className="w-full border rounded-lg px-4 py-3 min-h-[120px]"
            />

            <textarea
              name="situation"
              required
              placeholder="현재 취업/준비 상황 *"
              onChange={handleChange}
              className="w-full border rounded-lg px-4 py-3 min-h-[100px]"
            />

            <input
              name="experience"
              required
              placeholder="경력 (예: 3년 프론트엔드 / 신입 등) *"
              onChange={handleChange}
              className="w-full border rounded-lg px-4 py-3"
            />

            <select
              name="source"
              required
              onChange={handleChange}
              className="w-full border rounded-lg px-4 py-3"
            >
              <option value="">유입 경로 *</option>
              <option value="instagram">Instagram</option>
              <option value="threads">Threads</option>
              <option value="friend">지인</option>
              <option value="other">기타</option>
            </select>

            <input
              type="file"
              name="cv"
              required
              accept=".pdf,.doc,.docx"
              onChange={handleChange}
              className="w-full"
            />

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-main text-white py-4 rounded-xl font-bold hover:bg-hover transition disabled:opacity-50"
            >
              {loading ? "제출 중..." : "제출 완료하기"}
            </button>
          </form>
        )}
      </div>
    </section>
  );
};

export default ServiceRequestForm;
